module.exports = __webpack_public_path__ + "img/aston-main.e7788f1c.webp";